module.exports = __webpack_public_path__ + "static/media/zcdt_Up.4ddcce8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zcdt_Up.png
// module id = 1885
// module chunks = 0 1